import { z } from "zod";

/**
 * ParagraphNodeSchema - Content Schema for Paragraph Node
 *
 * Paragraph nodes are block-level containers for text and inline elements.
 */
export const ParagraphNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("paragraph"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  children: z.array(z.any()), // Array of child nodes (TextNode, StockNode, etc.)
  format: z.string().optional(), // Text alignment hint (left, center, right, justify)
  indent: z.number().optional(),
  direction: z.enum(["ltr", "rtl", "null"]).optional(),
}).strict();

export type ParagraphNode = z.infer<typeof ParagraphNodeSchema>;
